import { useEffect, useState } from "react";
import QRCode from "qrcode";

import apiClient from "../services/apiClient";

// 텔레그램 연결 창(2026-09-30). 연결 주소를 QR 과 버튼으로 함께 보여 준다.
// 새 탭으로 바로 보내면 텔레그램 앱이 없는 PC 에서는 '앱을 받으세요' 화면만 뜨고 끝나서
// 실제로 두 학원이 누르고도 이어지지 않았다. PC 에서는 휴대폰으로 QR 을 찍게 하고,
// 3초마다 이어졌는지 확인해 이어지면 바로 알려 준다.
const POLL_MS = 3000;
const POLL_LIMIT = 60;
const INSTALL_IOS = "https://apps.apple.com/app/telegram-messenger/id686449807";
const INSTALL_ANDROID = "https://play.google.com/store/apps/details?id=org.telegram.messenger";

const TelegramConnectDialog = ({ onClose, onConnected }) => {
  const [url, setUrl] = useState("");
  const [qrDataUrl, setQrDataUrl] = useState("");
  const [error, setError] = useState("");
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let timer = null;
    let startCount = 0;
    const load = async () => {
      try {
        const before = await apiClient.get("/api/v1/echo/teacher/telegram", { withAuth: true });
        startCount = (before.data.chat_list || []).length;
        const response = await apiClient.post("/api/v1/echo/teacher/telegram", { action: "connect" }, { withAuth: true });
        if (cancelled) return;
        setUrl(response.data.url);
        setQrDataUrl(await QRCode.toDataURL(response.data.url, { width: 220, margin: 1 }));
      } catch (caught) {
        setError(caught.response?.data?.error || "연결 주소를 만들지 못했어요.");
        return;
      }
      let tries = 0;
      const poll = async () => {
        tries += 1;
        try {
          const now = await apiClient.get("/api/v1/echo/teacher/telegram", { withAuth: true });
          if ((now.data.chat_list || []).length > startCount) {
            setConnected(true);
            onConnected?.(now.data);
            return;
          }
        } catch (ignored) {
          /* 잠깐의 오류는 다음 확인에서 다시 본다 */
        }
        if (!cancelled && tries < POLL_LIMIT) timer = setTimeout(poll, POLL_MS);
      };
      timer = setTimeout(poll, POLL_MS);
    };
    load();
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="tg-dialog" onClick={onClose}>
      <div className="tg-dialog__card" onClick={(event) => event.stopPropagation()}>
        <button type="button" className="tg-dialog__close" onClick={onClose} aria-label="닫기">✕</button>
        {connected ? (
          <div className="tg-dialog__done">
            <div className="tg-dialog__emoji">🎉</div>
            <b>연결됐어요!</b>
            <p>이제 텔레그램으로 소식을 받아요.</p>
            <button type="button" className="tg-dialog__main" onClick={onClose}>확인</button>
          </div>
        ) : (
          <>
            <b className="tg-dialog__title">텔레그램 연결</b>
            {error ? (
              <p className="tg-dialog__error">{error}</p>
            ) : (
              <>
                <div className="tg-dialog__qr">
                  {qrDataUrl ? <img src={qrDataUrl} alt="텔레그램 연결 QR" /> : <span>준비 중...</span>}
                </div>
                <ol className="tg-dialog__steps">
                  <li><b>휴대폰 카메라</b>로 QR 을 찍거나, 아래 버튼을 눌러요</li>
                  <li>텔레그램이 열리면 아래쪽 <b>시작</b>(START)을 눌러요</li>
                  <li>여기 화면이 "연결됐어요!" 로 바뀌면 끝!</li>
                </ol>
                <a className="tg-dialog__main" href={url || undefined} target="_blank" rel="noreferrer">
                  이 기기에서 텔레그램 열기
                </a>
                <p className="tg-dialog__install">
                  텔레그램 앱이 없으면 먼저 설치해 주세요:{" "}
                  <a href={INSTALL_IOS} target="_blank" rel="noreferrer">아이폰</a> ·{" "}
                  <a href={INSTALL_ANDROID} target="_blank" rel="noreferrer">안드로이드</a>
                </p>
                <p className="tg-dialog__wait">⏳ 시작을 누르길 기다리는 중이에요</p>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default TelegramConnectDialog;
